var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import GenericTable from "../../../../../../shared-library/components/GenericTable";
import ReportValue from "../../../../../../shared-library/components/commonTableVal";
import Loader from "../../../../../../shared-library/components/Loader";
import di from "../../di/serviceLocator";
import { useSelector } from "react-redux";
var ActiveLoansDetails = function (props) {
    var _a = __read(useState(false), 2), isShowLoader = _a[0], setIsShowLoader = _a[1];
    var _b = __read(useState([]), 2), collateralData = _b[0], setCollateralData = _b[1];
    var selectedAccount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var loanColumns = [
        {
            columnName: "Product",
            key: "LOANCODE",
        },
        {
            columnName: "Script Name",
            key: "SCRIPTNAME",
        },
        {
            columnName: "No of Shares",
            key: "NOOFSHARE",
            tdCustomFunction: function (key) {
                return React.createElement(ReportValue, { val: key, stream: false, onlyval: false });
            },
        },
        {
            columnName: "Current Mkt Price",
            key: "CURRETNMKTPRICE",
            tdCustomFunction: function (key) {
                return React.createElement(ReportValue, { val: key, stream: false, onlyval: false });
            },
        },
        {
            columnName: "Total Value",
            key: "TOTALVALUE",
            tdCustomFunction: function (key) {
                return React.createElement(ReportValue, { val: key, stream: false, onlyval: false });
            },
        },
        {
            columnName: "% Haircut",
            key: "HAIRCUT",
        },
    ];
    useEffect(function () {
        if ((props === null || props === void 0 ? void 0 : props.loanCode) !== "") {
            getCollaterals();
        }
    }, [props === null || props === void 0 ? void 0 : props.loanCode]);
    var getCollaterals = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsShowLoader(true);
                    return [4 /*yield*/, di.clients.getRevenueActiveLoanDetails({
                            Accode: props === null || props === void 0 ? void 0 : props.loanCode,
                        })];
                case 1:
                    response = _a.sent();
                    if (response.success && response.data && response.data.length) {
                        setCollateralData(response.data);
                        setIsShowLoader(false);
                    }
                    else {
                        setCollateralData([]);
                        setIsShowLoader(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(Row, { className: "mx-0 px-0 dpledger-block" },
        React.createElement(Row, { className: "px-0 mx-0" },
            React.createElement(Col, { className: "px-0 HeadRow d-flex justify-content-between align-items-center" },
                React.createElement("span", { className: "EncodeSansN_20_400 txt" },
                    React.createElement("i", { className: "edel-icon-arrow-left1", onClick: function () {
                            props.closePopup(false);
                        } }),
                    "Collaterals"))),
        React.createElement("div", { className: "padding-30" }, isShowLoader ? (React.createElement("div", { className: "position-relative client-loader" },
            React.createElement(Loader, null))) : (React.createElement(GenericTable, { columns: loanColumns, data: collateralData, parentClassName: "common-modal-table" })))));
};
export default ActiveLoansDetails;
